module.exports = __webpack_public_path__ + "static/img/mk73.f0c26ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/mk73.jpg
// module id = yCpG
// module chunks = 0